module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_WoodMatted_MockedUp.f2e789b2.jpg";